import {
  ArchiveMessagingCampaignMutationOptions,
  CreateMessagingCampaignMutationOptions,
  UpdateMessagingCampaignMutationOptions,
  useArchiveMessagingCampaignMutation,
  useCreateMessagingCampaignMutation,
  useUpdateMessagingCampaignMutation,
} from '@occc/graphql';
import { useMutation } from '@occc-app/dataAccessLayer/utils';

export const useArchiveMessagingCampaign = (
  baseOptions?: ArchiveMessagingCampaignMutationOptions,
) => {
  return useMutation(useArchiveMessagingCampaignMutation, baseOptions);
};

export const useCreateMessagingCampaign = (
  baseOptions?: CreateMessagingCampaignMutationOptions,
) => {
  return useMutation(useCreateMessagingCampaignMutation, baseOptions);
};
export const useUpdateMessagingCampaign = (
  baseOptions?: UpdateMessagingCampaignMutationOptions,
) => {
  return useMutation(useUpdateMessagingCampaignMutation, baseOptions);
};
